document.addEventListener("DOMContentLoaded", function (event) {
  class progressBar extends HTMLElement {
    constructor() {
      super();
      this.tab = document.querySelectorAll(".yg-progress-bar-tab li");
      this.barFrame = document.querySelectorAll(".yg-progress-bar-frame-box");
    }

    connectedCallback() {
      this.setActiveTab(this.tab, this.barFrame);
    }

    setActiveTab(tab, barFrame) {
      tab.forEach((tabItem, index) => {
        tabItem.addEventListener("click", (e) => {
          let container = e.srcElement.closest(".yg-progress-bar-container");
          let tab = container.querySelectorAll(".yg-progress-bar-tab li");
          let frame = container.querySelectorAll(".yg-progress-bar-frame-box");
          tab.forEach((tabItem, index) => {
            tabItem.classList.remove("active");
            frame[index].classList.remove("active");
          });
          tabItem.classList.add("active");
          barFrame[index].classList.add("active");
        });
      });
    }
  }

  customElements.define("yg-progress-bar", progressBar);

  (function () {
    let bannerContainers = document.querySelectorAll(
      ".yg-video-autoplay.yg-banner-text-container",
    );
    console.log(bannerContainers);
    bannerContainers.forEach((bannerContainer) => {
      let bannerVideo = bannerContainer.querySelectorAll("video");
      if (bannerVideo.length > 0) {
        let observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              console.log("点击我");
              bannerVideo.forEach((video) => {
                video.play();
              });
              observer.unobserve(entry.target);
            }
          });
        });
        observer.observe(bannerContainer);
      }
    });
  })();
});
